import React from 'react';
import '../css/Buttons.css';
import { NavLink, useNavigate } from 'react-router-dom';

const ButtonLarge = ({ 
  label, 
  icon: Icon, 
  onClick, 
  to, 
  style, 
  className = '', 
  setIsButtonHovered, 
  disabled = false, // Added disabled prop
  variant = 'filled' // 'filled' (default) or 'outlined'
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return; // Prevent click when disabled
    if (to) {
      navigate(to);
    } else if (onClick) {
      onClick();
    }
  };

  const variantClass = variant === 'outlined' ? 'button-large-outlined' : 'button-large-filled';

  return to ? (
    <NavLink
      to={to}
      className={({ isActive }) => `button-large ${variantClass} ${className} ${isActive ? 'active' : ''} ${disabled ? 'disabled' : ''}`}
      style={style}
      onMouseEnter={() => setIsButtonHovered && setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered && setIsButtonHovered(false)}
    >
      {Icon && <Icon className="button-large-icon" />}
      {label}
    </NavLink>
  ) : (
    <button
      className={`button-large ${variantClass} hover-button ${className} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
      style={style}
      disabled={disabled}
      onMouseEnter={() => setIsButtonHovered && setIsButtonHovered(true)}
      onMouseLeave={() => setIsButtonHovered && setIsButtonHovered(false)}
    >
      {Icon && <Icon className="button-large-icon" />}
      {label}
    </button>
  );
};

export default ButtonLarge;
